import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCleaningSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "white",
			children: [/* @__PURE__ */ _jsx("circle", {
				className: "icon-white",
				cx: 12.76,
				cy: 4.86,
				r: 1.14
			}), /* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "m16.35,9.53c.4-.28.66-.74.66-1.27,0-.86-.7-1.55-1.55-1.55s-1.48.63-1.55,1.43l-1.44-.82L3.48,12.42v2.46l9.02,5.21,8.96-5.18v-2.46l-5.12-2.92Z"
			})]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "grey",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "m21.52,12.22c-.13,0-.23.1-.23.23v2.45l-8.5,4.91v-2.19c0-.13-.1-.23-.23-.23s-.23.1-.23.23v2.19L3.76,14.88v-2.45c0-.13-.1-.23-.23-.23s-.23.1-.23.23v2.59c0,.08.04.16.12.2l9.02,5.21s.08.03.12.03.08-.01.12-.03l8.96-5.18c.07-.04.12-.12.12-.2v-2.59c0-.13-.1-.23-.23-.23Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "color",
			children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m12.81,6.24c.75,0,1.36-.61,1.36-1.36,0-.75-.61-1.36-1.36-1.36s-1.36.61-1.36,1.36.61,1.36,1.36,1.36Zm-.79-1.36c0-.43.35-.79.79-.79s.79.35.79.79-.35.79-.79.79-.79-.35-.79-.79Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m5.42,11.08c-.08-.02-.16,0-.23.03l-.72.42c-.15.08-.2.27-.11.42.06.09.16.15.27.15.05,0,.1-.01.15-.04l.72-.42c.07-.04.12-.11.14-.19.02-.08.01-.16-.03-.23-.04-.07-.11-.12-.19-.14Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m6.86,10.25c-.08-.02-.16-.01-.23.03l-.72.42c-.15.08-.2.27-.11.42.06.1.16.15.27.15.05,0,.11-.01.15-.04l.72-.42c.07-.04.12-.11.14-.19.02-.08,0-.16-.03-.23-.04-.07-.11-.12-.19-.14Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m10.54,16.11c-.07-.04-.15-.05-.23-.03-.08.02-.15.07-.19.14-.04.07-.05.15-.03.23s.07.15.14.19l.72.42s.1.04.15.04c.11,0,.21-.06.27-.16.08-.15.03-.34-.11-.42l-.72-.42Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m9.1,15.28c-.07-.04-.15-.05-.23-.03-.08.02-.15.07-.19.14-.04.07-.05.15-.03.23.02.08.07.15.14.19l.72.42s.1.04.15.04c.11,0,.21-.06.27-.15.04-.07.05-.15.03-.23s-.07-.15-.14-.19l-.72-.42Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m8.3,9.42c-.08-.02-.16,0-.23.03l-.72.42c-.07.04-.12.11-.14.19-.02.08-.01.16.03.24.06.1.16.15.27.15.05,0,.1-.01.15-.04l.72-.42c.07-.04.12-.11.14-.19.02-.08.01-.16-.03-.23-.04-.07-.11-.12-.19-.14Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m7.66,14.45c-.07-.04-.15-.05-.23-.03-.08.02-.15.07-.19.14-.04.07-.05.15-.03.23.02.08.07.15.14.19l.72.42s.1.04.15.04c.11,0,.21-.06.27-.15.08-.15.03-.34-.11-.42l-.72-.42Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m12.65,6.98c-.1-.06-.22-.06-.31,0l-.67.38c-.07.04-.12.11-.14.19-.02.08-.01.16.03.23.06.1.16.15.27.15.05,0,.1-.01.15-.04l.54-.31c.12.01.23-.05.29-.15.08-.15.03-.34-.11-.42l-.06-.03Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m10.39,8.77c.05,0,.11-.01.15-.04l.72-.42c.07-.04.12-.11.14-.19s.01-.16-.03-.23-.11-.12-.19-.14c-.08-.02-.16-.01-.23.03l-.72.42c-.15.08-.2.27-.11.42.06.1.16.15.27.15Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m4.77,12.78c-.07-.04-.15-.05-.23-.03-.08.02-.15.07-.19.14-.04.07-.05.15-.03.23.02.08.07.15.14.19l.72.42s.1.04.15.04c.11,0,.21-.06.27-.15.04-.07.05-.15.03-.23-.02-.08-.07-.15-.14-.19l-.72-.42Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m8.95,9.61c.05,0,.11-.01.15-.04l.72-.42c.07-.04.12-.11.14-.19.02-.08.01-.16-.03-.23-.04-.07-.11-.12-.19-.14-.08-.02-.16,0-.23.03l-.72.42c-.15.08-.2.27-.11.42.05.09.16.15.27.15Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m4.19,12.29c.02-.08.01-.16-.03-.23-.04-.07-.11-.12-.19-.14-.08-.02-.16,0-.23.03l-.36.21c-.1.05-.15.16-.15.27s.06.21.15.27l.36.21s.1.04.15.04c.11,0,.21-.06.27-.15.07-.12.05-.27-.04-.36.03-.04.06-.08.07-.13Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m6.21,13.61c-.07-.04-.15-.05-.23-.03-.08.02-.15.07-.19.14-.04.07-.05.15-.03.23.02.08.07.15.14.19l.72.42s.1.04.15.04c.11,0,.21-.06.27-.15.04-.07.05-.15.03-.23-.02-.08-.07-.15-.14-.19l-.72-.42Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m18.3,14.07c-.08-.02-.16-.01-.24.03l-.72.42c-.15.08-.2.27-.11.42.05.1.16.15.27.15.06,0,.11-.02.15-.04l.72-.42c.07-.04.12-.11.14-.19.02-.08,0-.16-.03-.23s-.11-.12-.19-.14Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m16.88,9.42c.25-.32.4-.7.4-1.11,0-.98-.8-1.78-1.77-1.78-.74,0-1.38.46-1.64,1.14l-.43-.25c-.15-.08-.34-.03-.42.11h0c-.04.07-.05.16-.03.23.02.08.07.15.14.19l.61.35c0,.98.8,1.78,1.77,1.78.31,0,.61-.09.88-.25l.34.2s.1.04.16.04c.11,0,.21-.06.27-.15.08-.15.03-.34-.11-.42l-.16-.09Zm-1.38.1c-.66,0-1.2-.54-1.2-1.21,0-.03,0-.06,0-.09v-.02c.06-.63.57-1.1,1.2-1.1s1.14.47,1.2,1.1v.02s0,.06,0,.09c0,.33-.13.64-.38.88-.1.1-.22.18-.35.23-.15.06-.31.1-.47.1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m21.37,12.01l-.72-.42c-.07-.04-.16-.05-.24-.03-.08.02-.15.07-.19.14-.04.07-.05.15-.03.23.02.08.07.15.14.19l.56.33-.68.39c-.07.04-.12.11-.14.19-.02.08-.01.16.03.24.06.09.16.15.27.15.06,0,.11-.01.15-.04l.72-.42c.15-.08.2-.27.11-.42.05-.03.08-.06.11-.11.08-.15.03-.34-.11-.42Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m19.2,10.76c-.15-.08-.34-.03-.42.11-.08.15-.03.34.11.42l.72.42s.1.04.16.04c.11,0,.21-.06.27-.15.04-.07.05-.15.03-.23-.02-.08-.07-.15-.14-.19l-.72-.42Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m17.76,9.93c-.07-.04-.15-.05-.23-.03s-.15.07-.19.14c-.08.15-.03.34.11.42l.72.42s.1.04.15.04c.11,0,.21-.06.27-.15.04-.07.05-.15.03-.23-.02-.08-.07-.15-.14-.19l-.72-.42Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m19.74,13.23c-.08-.02-.16-.01-.23.03l-.72.42c-.15.08-.2.27-.11.42.06.1.16.15.27.15.06,0,.11-.01.15-.04l.72-.42c.15-.08.2-.27.11-.42-.04-.07-.11-.12-.19-.14Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m13.96,16.56c-.08-.02-.16-.01-.23.03l-.72.42c-.15.08-.2.27-.11.42.05.1.16.15.27.15.06,0,.11-.01.15-.04l.72-.42c.07-.04.12-.11.14-.19s.01-.16-.03-.23c-.04-.07-.11-.12-.19-.14Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m16.62,14.93l-.72.42c-.07.04-.12.11-.14.19-.02.08-.01.16.03.23.06.09.16.15.27.15.06,0,.11-.01.15-.04l.72-.42c.15-.08.2-.27.11-.42-.08-.15-.27-.2-.42-.11Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m11.99,16.95c-.07-.04-.15-.05-.23-.03-.08.02-.15.07-.19.14-.04.07-.05.15-.03.23.02.08.07.15.14.19l.72.42s.1.04.15.04c.11,0,.21-.06.27-.15.08-.15.03-.34-.11-.42l-.72-.42Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m15.41,15.73c-.08-.02-.16-.01-.24.03l-.72.42c-.15.08-.2.27-.11.42.06.1.16.15.27.15.06,0,.11-.01.15-.04l.72-.42c.07-.04.12-.11.14-.19.02-.08.01-.16-.03-.23-.04-.07-.11-.12-.19-.14Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m11.87,9.22c-1.35,0-2.44,1.1-2.44,2.45s1.09,2.44,2.44,2.44,2.44-1.1,2.44-2.44c0-.65-.25-1.27-.72-1.73-.46-.46-1.08-.72-1.72-.72Zm1.87,2.45c0,1.03-.84,1.87-1.87,1.87s-1.87-.84-1.87-1.87.84-1.87,1.87-1.87,1.87.84,1.87,1.87Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m11.87,10.2c-.82,0-1.48.67-1.48,1.49,0,.16.13.29.28.29s.28-.13.28-.29c0-.5.41-.92.91-.92.16,0,.28-.13.28-.29s-.13-.28-.28-.28Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m15.51,7.4c-.51,0-.92.42-.93.93,0,.16.13.29.28.29.08,0,.16-.04.21-.1.04-.05.07-.12.07-.19,0-.2.16-.36.36-.36.16,0,.28-.13.28-.28,0-.08-.03-.15-.08-.2-.05-.05-.13-.08-.2-.08Z"
				})
			] })
		})
	]
});
export default SvgCleaningSm;
